(() => {
  if (customElements.get('covalt-backorder-dispatch')) return;

  class BackorderDispatch extends HTMLElement {
    connectedCallback() {
      this.status = this.querySelector('[data-dispatch-status]');
      this.scope = this.closest('[data-section-type]');
      this.onVariantChanged = (event) => {
        if (!event.target.contains(this)) return;
        const variant = event.detail && event.detail.variant;
        this.dataset.variantId = variant && variant.available ? String(variant.id) : '';
        this.update();
      };
      this.onVisibility = () => this.update();
      this.scope?.addEventListener('variant:changed', this.onVariantChanged);
      document.addEventListener('visibilitychange', this.onVisibility);
      this.timer = window.setInterval(() => this.update(), 60000);
      this.update();
    }

    disconnectedCallback() {
      this.scope?.removeEventListener('variant:changed', this.onVariantChanged);
      document.removeEventListener('visibilitychange', this.onVisibility);
      window.clearInterval(this.timer);
    }

    update() {
      if (!this.status) return;
      const source = Array.from(this.querySelectorAll('template[data-dispatch-variant]'))
        .find((item) => item.dataset.dispatchVariant === this.dataset.variantId);
      const notice = source?.content.querySelector('[data-dispatch-date]');
      const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/Monterrey', year: 'numeric', month: '2-digit', day: '2-digit'
      }).formatToParts(new Date());
      const part = (name) => parts.find((item) => item.type === name).value;
      const today = `${part('year')}-${part('month')}-${part('day')}`;
      const content = notice && notice.dataset.dispatchDate >= today ? notice : null;
      const nextText = content ? content.textContent : '';
      if (this.status.textContent !== nextText) {
        this.status.replaceChildren(...(content ? [content.cloneNode(true)] : []));
      }
    }
  }

  customElements.define('covalt-backorder-dispatch', BackorderDispatch);
})();
